import {
    USUARIOS_UPDATE_USER_PASSWORD_BEGIN,
    USUARIOS_UPDATE_USER_PASSWORD_SUCCESS,
    USUARIOS_UPDATE_USER_PASSWORD_FAILURE,
    USUARIOS_UPDATE_USER_PASSWORD_DISMISS_ERROR
   } from './constants';
   import axios from "axios";
   import { REACT_APP_API_ABM_FW } from '../../../common/config';
   import md5 from 'md5';
 
   export function updateUserPassword(body) {
     return (dispatch) => { 
       dispatch({
         type: USUARIOS_UPDATE_USER_PASSWORD_BEGIN,
       });
       const promise = new Promise((resolve, reject) => {
         const doRequest = axios.put(REACT_APP_API_ABM_FW + "/users/updatePassword", 
         {
           currentPassword: md5(body.currentPassword),
           newPassword: md5(body.newPassword)
         }, {validateStatus: (status) => {
          return true;
        }});
         doRequest.then(
           (res) => {
             if (res.data.success) {
               dispatch({
                 type: USUARIOS_UPDATE_USER_PASSWORD_SUCCESS,
                 data: res,
               });
               resolve(res);
             } else {
               dispatch({
                 type: USUARIOS_UPDATE_USER_PASSWORD_FAILURE,
                 data: res.data,
               });
               reject(res.data.errorMessage);
             }
           },
           (err) => {
             dispatch({
               type: USUARIOS_UPDATE_USER_PASSWORD_FAILURE,
               data: { error: err },
             });
             reject(err);
           },
         );
       });
       return promise;
     };
   }
   
   export function dismissUpdateUserPassword() {
     return {
       type: USUARIOS_UPDATE_USER_PASSWORD_DISMISS_ERROR,
     };
   }
   
   export function reducer(state, action) {
     switch (action.type) {
       case USUARIOS_UPDATE_USER_PASSWORD_BEGIN:
         return {
           ...state,
           updateUserPasswordPending: true,
           updateUserPasswordError: null,
         };
   
       case USUARIOS_UPDATE_USER_PASSWORD_SUCCESS:
         return {
           ...state,
           updateUserPasswordPending: false,
           updateUserPasswordError: null,
         };
   
       case USUARIOS_UPDATE_USER_PASSWORD_FAILURE:
         return {
           ...state,
           updateUserPasswordPending: false,
           updateUserPasswordError: action.data.errorMessage,
         };
   
       case USUARIOS_UPDATE_USER_PASSWORD_DISMISS_ERROR:
         return {
           ...state,
           updateUserPasswordError: null,
         };
 
       default:
         return state;
     }
   }
   